import React from "react";
import { formatToINR } from "../../../../helpers/utility";
import styles from "./PackagesIp.module.css";

const PatientPackageTable = ({ data }) => {
  const rows = data?.package_services || [];

  if (!rows.length) {
    return (
      <div className={styles.packageServicesTable}>
        <p className={styles.packageServicesEmpty}>No services found.</p>
      </div>
    );
  }

  return (
    <div className={styles.packageServicesTable}>
      <div className={styles.packageServicesTableHeader}>
        <span className={styles.packageServicesColLabel}>Item</span>
        <span className={styles.packageServicesColLabel}>Type</span>
        <span
          className={`${styles.packageServicesColLabel} ${styles.packageServicesColEnd}`}
        >
          Price
        </span>
      </div>

      <div className={styles.packageServicesTableBody}>
        {rows.map((record, index) => {
          const itemName =
            record?.service?.name ||
            record?.investigation?.name ||
            record?.name ||
            "—";
          const itemType = record?.investigation
            ? "Investigation"
            : record?.service
            ? "Service"
            : "Service";
          const price = formatToINR(
            record?.final_price ??
              record?.price ??
              data?.package?.room_price ??
              0
          );

          return (
            <div
              key={record?.id ?? record?.service?.id ?? `service-${index}`}
              className={styles.packageServicesTableRow}
            >
              <div className={styles.packageServicesItemGroup}>
                <span className={styles.packageServicesCell}>{itemName}</span>
                <span
                  className={`${styles.packageServicesCellMuted} ${styles.packageServicesTypeInline}`}
                >
                  {itemType}
                </span>
              </div>
              <span
                className={`${styles.packageServicesCellMuted} ${styles.packageServicesTypeCol}`}
              >
                {itemType}
              </span>
              <span
                className={`${styles.packageServicesCellPrice} ${styles.packageServicesColEnd}`}
              >
                {price}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PatientPackageTable;
